<section class="intro">
    <h2>Asociatie familiala</h2>
    <h3>Principala activitate - cresterea si vanzarea plantelor conifere</h3>


</section>

<section class="timeline">
    <ul>
        <li>
            <div>
                <time>2013</time>
                <div class="discovery">
                    <h1>Deschidere</h1>
                    <p>
                        Am inceput sa punem bazele noii noastre afaceri.
                    </p>
                </div>

            </div>
        </li>
        <li>
            <div>
                <time>2013</time>
                <div class="discovery">
                    <h1>Plantare</h1>
                    <p>
                        Am plantat primul puiet.
                    </p>
                </div>
                <div class="scientist">
                    <a target="_blank" href="/assets/pics/Start.jpg"><img src="/assets/pics/Start.jpg"></a>
                </div>
            </div>
        </li>
        <li>
            <div>
                <time>2015</time>
                <div class="discovery">
                    <h1>Tuia Smaragd</h1>
                    <p>
                        Am facut prima livrare.
                    </p>
                </div>
                <div class="scientist">
                    <a target="_blank" href="/assets/pics/tuja/TuiaSmaragd.jpg"><img src="/assets/pics/tuja/TuiaSmaragd.jpg"></a>
                </div>
            </div>
        </li>
        <li>
            <div>
                <time>2015</time>
                <div class="discovery">
                    <h1>Amenajare</h1>
                    <p>
                        Am amenajat prima gradina.
                    </p>
                </div>
                <div class="scientist">
                    <a target="_blank" href="/assets/pics/amenajare1.jpg"><img src="/assets/pics/amenajare1.jpg"></a>
                </div>
            </div>
        </li>
        <li>
            <div>
                <time>2017</time>
                <div class="discovery">
                    <h1>Diversificare</h1>
                    <p>
                        La solicitarile clientilor am inceput diversificarea gamei de produse.
                    </p>
                </div>
                <div class="scientist">
                    <a target="_blank" href="/assets/pics/5.jpg"><img src="/assets/pics/5.jpg"></a>
                </div>
            </div>
        </li>
        <li>
            <div>
                <time>2021</time>
                <div class="discovery">
                    <h1>Va asteptam cu drag</h1>
                    <p>
                        Povestea noastra continua.
                    </p>
                </div>

            </div>
        </li>
    </ul>

</section>